import React from 'react'
import BrandName from './BrandName'
import { ProfilerQuestionID } from '../../config/QuestionEnum'
import { getQuestionConfig } from '../../config/questionsConfig';
import { PROFILER_IMAGES } from '../../Common/constants';
const questionConfig = getQuestionConfig(ProfilerQuestionID.BCM_ELECTRICALS_SUPPLIERS_BRANDS);

const BCMBrandElectricalsSuppliers = (props) => {
  return (
    <BrandName
      questionId={ProfilerQuestionID.BCM_ELECTRICALS_SUPPLIERS_BRANDS}
      title={questionConfig?.question}
      subtitle={questionConfig?.subtitle}
      options={questionConfig?.options || []}
      suggestions={['Havells', 'Anchor', 'Polycab', 'Finolex Cables', 'RR Kabel']}
      icon={PROFILER_IMAGES.electrical_supplies}
      {...props}
    />
  )
}

export default BCMBrandElectricalsSuppliers
